import React, { useEffect, useContext, useState } from "react";
import Header from "../../components/Layout/Header";
import Sidebar from "../../components/Layout/Sidebar";
import Main from "../../components/Layout/Main";
import { Modal, Button, Form } from "react-bootstrap";
import CustomersContext from "../../context/otogas/customers/customersContext";
import SweetAlertWrapper from "../../components/Layout/sweetAlert";
import { download_customer_balances, download_cutomer_wallet_topup_history, upload_vouchers_excel, download_vouchers, download_personal_wallet_statement } from "../../api/otogas";
import FileUpload from "../../components/util/uploader";
import DownloadButton from "../../components/util/downloader";
import Pagination from "../../components/Layout/Pagination";
import VehicleTopupModal from "./topupCustomer";
import SetCreditLimitModal from "./setCreditLimit";

const ListCustomerBalances = () => {
    const safeFormatCurrency = (amount) => {
        const numericAmount = Number(amount);
        const value = Number.isFinite(numericAmount) ? numericAmount : 0;

        return `KES ${value.toLocaleString("en-KE", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        })}`;
    };
    const customersContext = useContext(CustomersContext);
    const {
        customer_balances,
        notification,
        clear_notification,
        allCustomerBalances,
        topUpCustomerBalance,
        uploadSalesData,
        wallets_total_records,
        personal_wallets,
        personal_wallets_wallets_total_records,
        personalWalletBalances,
        topUpPersonalWallet,
        getPersonalWalletStatement,
        vouchers,
        vouchers_total_records,
        listVouchers
    } = customersContext;

    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(16);
    const [showModal, setShowModal] = useState(false);
    const [vehicleRegistrationNumber, setVehicleRegistrationNumber] = useState("");
    const [customerName, setCustomerName] = useState("");
    const [selectedCustomerBalance, setSelectedCustomerBalance] = useState(null);
    const [topUpAmount, setTopUpAmount] = useState("");
    const [paymentReference, setPaymentReference] = useState("");
    const [downloading, setDownloading] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState({ text: "", type: "" });
    const [showTopupModal, setShowTopupModal] = useState(false);
    const [showSetCreditLimitModal, setShowSetCreditLimitModal] = useState(false);
    const [vehicle, setVehicle] = useState(null);
    const [activeTab, setActiveTab] = useState("customer");

    // Personal Wallet Search
    const [walletId, setWalletId] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [searchName, setSearchName] = useState("");
    const [identificationNumber, setIdentificationNumber] = useState("");
    const [selectedPersonalWallet, setSelectedPersonalWallet] = useState(null);
    const [showPersonalTopupModal, setShowPersonalTopupModal] = useState(false);
    const [personalTopupAmount, setPersonalTopupAmount] = useState("");
    const [personalTopupReference, setPersonalTopupReference] = useState("");
    const [submittingPersonalTopup, setSubmittingPersonalTopup] = useState(false);
    const [showStatementModal, setShowStatementModal] = useState(false);
    const [statementRows, setStatementRows] = useState([]);
    const [statementLoading, setStatementLoading] = useState(false);
    const [statementDownloading, setStatementDownloading] = useState(false);
    const [statementStartDate, setStatementStartDate] = useState(() => {
        const date = new Date();
        date.setDate(1);
        return date.toISOString().slice(0, 10);
    });
    const [statementEndDate, setStatementEndDate] = useState(() => new Date().toISOString().slice(0, 10));

    useEffect(() => {
        if (activeTab === "customer") {
            allCustomerBalances(vehicleRegistrationNumber, customerName, currentPage, itemsPerPage);
        }
    }, [activeTab, vehicleRegistrationNumber, customerName, currentPage, itemsPerPage]);

    useEffect(() => {
        if (activeTab === "personal") {
            personalWalletBalances(walletId, phoneNumber, searchName, identificationNumber, currentPage, itemsPerPage);
        }
    }, [activeTab, walletId, phoneNumber, searchName, identificationNumber, currentPage, itemsPerPage]);

    useEffect(() => {
        if (activeTab === "vouchers") {
            listVouchers(currentPage, itemsPerPage);
        }
    }, [activeTab, currentPage, itemsPerPage]);

    useEffect(() => {
        if (notification) {
            setAlertMessage({
                text: notification.text,
                type: notification.type,
            });
            setShowAlert(true);
        }
    }, [notification]);

    const handleConfirm = () => {
        setShowAlert(false);
        clear_notification();
    };

    const handleTopUp = (balance) => {
        setSelectedCustomerBalance(balance);
        setShowModal(true);
    };

    const handleTopUpSubmit = async () => {
        if (topUpAmount && paymentReference) {
            try {
                await topUpCustomerBalance({
                    vehicleCode: selectedCustomerBalance.vehicleCode,
                    amount: parseFloat(topUpAmount),
                    paymentReference,
                });
                setShowModal(false);
            } catch (error) {

            }
        }
    };

    const handleDownloadBalances = async () => {
        try {
            setDownloading(true);
            await download_customer_balances();
        } catch (error) {
        } finally {
            setDownloading(false);
        }
    };

    const handleDownloadVouchers = async () => {
        try {
            setDownloading(true);
            await download_vouchers();
        } catch (error) {
        } finally {
            setDownloading(false);
        }
    };

    const handleSearchKeyPress = (e) => {
        if (e.key === "Enter") {
            setCurrentPage(1);
            allCustomerBalances(vehicleRegistrationNumber, customerName, currentPage, itemsPerPage);
        }
    };

    const getPersonalWalletName = (wallet) =>
        [wallet?.firstName, wallet?.middleName, wallet?.lastName]
            .filter(Boolean)
            .join(" ");

    const openPersonalTopupModal = (wallet) => {
        setSelectedPersonalWallet(wallet);
        setPersonalTopupAmount("");
        setPersonalTopupReference("");
        setShowPersonalTopupModal(true);
    };

    const handlePersonalTopupSubmit = async () => {
        const amount = Number(personalTopupAmount);

        if (!selectedPersonalWallet || !amount || amount <= 0 || !personalTopupReference.trim()) {
            setAlertMessage({
                text: "Enter a valid amount and transaction reference.",
                type: "warning",
            });
            setShowAlert(true);
            return;
        }

        try {
            setSubmittingPersonalTopup(true);
            const response = await topUpPersonalWallet({
                walletId: selectedPersonalWallet.walletId,
                amount,
                vehicleCode: personalTopupReference.trim(),
            });

            if (response?.responseCode === 1) {
                setShowPersonalTopupModal(false);
                await personalWalletBalances(
                    walletId,
                    phoneNumber,
                    searchName,
                    identificationNumber,
                    currentPage,
                    itemsPerPage,
                );
            }
        } finally {
            setSubmittingPersonalTopup(false);
        }
    };

    const loadPersonalWalletStatement = async (wallet = selectedPersonalWallet) => {
        if (!wallet) return;

        try {
            setStatementLoading(true);
            const response = await getPersonalWalletStatement(
                wallet.walletId,
                statementStartDate,
                statementEndDate,
            );
            setStatementRows(response?.responseCode === 1 ? response.responseObject || [] : []);
        } finally {
            setStatementLoading(false);
        }
    };

    const openPersonalWalletStatement = async (wallet) => {
        setSelectedPersonalWallet(wallet);
        setStatementRows([]);
        setShowStatementModal(true);
        await loadPersonalWalletStatement(wallet);
    };

    const exportPersonalWalletStatement = async (wallet = selectedPersonalWallet) => {
        if (!wallet) return;

        try {
            setStatementDownloading(true);
            const result = await download_personal_wallet_statement(
                wallet.walletId,
                statementStartDate,
                statementEndDate,
            );

            if (!result?.success) {
                setAlertMessage({
                    text: result?.message || "Unable to download the wallet statement.",
                    type: "error",
                });
                setShowAlert(true);
            }
        } finally {
            setStatementDownloading(false);
        }
    };




    return (
        <>
            <Header />
            <Sidebar />
            <Main>
                <SweetAlertWrapper
                    show={showAlert}
                    title="Notification"
                    message={alertMessage.text}
                    onConfirm={handleConfirm}
                    confirmBtnText="OK"
                    type={alertMessage.type || "info"}
                />

                {showTopupModal && (
                    <VehicleTopupModal
                        show={showTopupModal}
                        handleClose={() => setShowTopupModal(false)}
                        vehicle={vehicle}
                    />
                )}

                {showSetCreditLimitModal && (
                    <SetCreditLimitModal
                        show={showSetCreditLimitModal}
                        handleClose={() => setShowSetCreditLimitModal(false)}
                        vehicle={vehicle}
                    />
                )}

                <ul className="nav nav-tabs mb-3">
                    <li className="nav-item">
                        <button className={`nav-link ${activeTab === "customer" ? "active" : ""}`} onClick={() => setActiveTab("customer")}>
                            Customer Balances
                        </button>
                    </li>
                    <li className="nav-item">
                        <button className={`nav-link ${activeTab === "personal" ? "active" : ""}`} onClick={() => setActiveTab("personal")}>
                            Personal Wallets
                        </button>
                    </li>
                    <li className="nav-item">
                        <button className={`nav-link ${activeTab === "vouchers" ? "active" : ""}`} onClick={() => setActiveTab("vouchers")}>
                            Vouchers
                        </button>
                    </li>
                </ul>

                {activeTab === "customer" && (
                    <>
                        <div className="row mb-3">
                            <div className="col-md-12 d-flex justify-content-end">
                                <button className="btn btn-success m-1" onClick={handleDownloadBalances} disabled={downloading}>
                                    {downloading ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                            Downloading...
                                        </>
                                    ) : (
                                        "Download Balances"
                                    )}
                                </button>

                                <FileUpload
                                    uploadFunction={uploadSalesData}
                                    name="Upload balances"
                                    allowed_file_types={[".xlsx", ".xls"]}
                                />

                                <DownloadButton
                                    className="btn btn-secondary btn-group-sm m-1"
                                    existingFunction={download_cutomer_wallet_topup_history}
                                    buttonName="Export Topup History"
                                    reportType="range"
                                />
                            </div>
                        </div>


                        <form className="mb-3">
                            <div className="row">
                                <div className="col-md-6">
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={customerName}
                                        onChange={(e) => setCustomerName(e.target.value)}
                                        onKeyPress={handleSearchKeyPress}
                                        placeholder="Search by Name"
                                    />
                                </div>
                                <div className="col-md-6">
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={vehicleRegistrationNumber}
                                        onChange={(e) => setVehicleRegistrationNumber(e.target.value)}
                                        onKeyPress={handleSearchKeyPress}
                                        placeholder="Search by Vehicle Registration Number"
                                    />
                                </div>
                            </div>
                        </form>

                        <table className="table">
                            <thead>
                                <tr>
                                    <th>Customer Name</th>
                                    <th>Balance Amount</th>
                                    <th>Registration Number</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {customer_balances.map((balance) => (
                                    <tr key={balance.customerId}>
                                        <td>{balance.customerName}</td>
                                        <td>{safeFormatCurrency(balance.balance)}</td>
                                        <td>{balance.registrationNumber}</td>
                                        <td>
                                            <div className="dropdown">
                                                <button className="btn btn-custom-actions dropdown-toggle" type="button" data-bs-toggle="dropdown">
                                                    Actions
                                                </button>
                                                <ul className="dropdown-menu">
                                                    <li>
                                                        <button className="dropdown-item" onClick={() => handleTopUp(balance)}>
                                                            Top-up Balance
                                                        </button>
                                                    </li>
                                                    <li>
                                                        <button
                                                            className="dropdown-item"
                                                            onClick={() => {
                                                                setVehicle({
                                                                    vehicleCode: balance.vehicleCode,
                                                                    vehicleRegistrationNumber: balance.registrationNumber,
                                                                    customerName: balance.customerName,
                                                                });
                                                                setShowSetCreditLimitModal(true);
                                                            }}
                                                        >
                                                            Set Credit Limit
                                                        </button>
                                                    </li>
                                                </ul>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        {wallets_total_records > 1 && (
                            <Pagination
                                currentPage={currentPage}
                                totalPages={Math.ceil(wallets_total_records / itemsPerPage)}
                                setCurrentPage={setCurrentPage}
                            />
                        )}
                    </>
                )}

                {activeTab === "personal" && (
                    <>
                        <div className="row mb-3">
                            <div className="col-md-3">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search by Wallet ID"
                                    value={walletId}
                                    onChange={(e) => setWalletId(e.target.value)}
                                />
                            </div>
                            <div className="col-md-3">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Phone Number"
                                    value={phoneNumber}
                                    onChange={(e) => setPhoneNumber(e.target.value)}
                                />
                            </div>
                            <div className="col-md-3">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Name"
                                    value={searchName}
                                    onChange={(e) => setSearchName(e.target.value)}
                                />
                            </div>
                            <div className="col-md-3">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="ID Number"
                                    value={identificationNumber}
                                    onChange={(e) => setIdentificationNumber(e.target.value)}
                                />
                            </div>
                        </div>

                        <table className="table">
                            <thead>
                                <tr>
                                    <th>Wallet ID</th>
                                    <th>Name</th>
                                    <th>Phone</th>
                                    <th>ID Number</th>
                                    <th>Balance</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {personal_wallets.map((wallet) => (
                                    <tr key={wallet.walletId}>
                                        <td>{wallet.walletId}</td>
                                        <td>{wallet.firstName} {wallet.middleName} {wallet.lastName}</td>
                                        <td>{wallet.phoneNumber}</td>
                                        <td>{wallet.identificationNumber}</td>
                                        <td>{safeFormatCurrency(wallet.balance ?? wallet.credit)}</td>
                                        <td>
                                            <div className="dropdown">
                                                <button
                                                    className="btn btn-custom-actions dropdown-toggle"
                                                    type="button"
                                                    data-bs-toggle="dropdown"
                                                >
                                                    Actions
                                                </button>
                                                <ul className="dropdown-menu dropdown-menu-end">
                                                    <li>
                                                        <button
                                                            type="button"
                                                            className="dropdown-item"
                                                            onClick={() => openPersonalTopupModal(wallet)}
                                                        >
                                                            Top Up
                                                        </button>
                                                    </li>
                                                    <li>
                                                        <button
                                                            type="button"
                                                            className="dropdown-item"
                                                            onClick={() => openPersonalWalletStatement(wallet)}
                                                        >
                                                            View Statement
                                                        </button>
                                                    </li>
                                                    <li>
                                                        <button
                                                            type="button"
                                                            className="dropdown-item"
                                                            onClick={() => exportPersonalWalletStatement(wallet)}
                                                            disabled={statementDownloading}
                                                        >
                                                            Export Statement
                                                        </button>
                                                    </li>
                                                </ul>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        {personal_wallets_wallets_total_records > 1 && (
                            <Pagination
                                currentPage={currentPage}
                                totalPages={Math.ceil(personal_wallets_wallets_total_records / itemsPerPage)}
                                setCurrentPage={setCurrentPage}
                            />
                        )}
                    </>
                )}

                {activeTab === "vouchers" && (
                    <>
                        <div className="row mb-3">
                            <div className="col-md-4 offset-md-8 d-flex justify-content-end">
                                <FileUpload
                                    uploadFunction={upload_vouchers_excel}
                                    name="Upload Vouchers"
                                    allowed_file_types={[".xlsx", ".xls"]}
                                />

                                <button className="btn btn-success m-1" onClick={handleDownloadVouchers} disabled={downloading}>
                                    {downloading ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                            Downloading...
                                        </>
                                    ) : (
                                        "Download Vouchers"
                                    )}
                                </button>


                            </div>
                        </div>

                        <table className="table">
                            <thead>
                                <tr>
                                    <th>Voucher Number</th>
                                    <th>Amount</th>
                                    <th>Vehicle Reg No</th>
                                    <th>Date Created</th>
                                    <th>Expiry Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {vouchers.map((voucher) => (
                                    <tr key={voucher.voucherNo}>
                                        <td>{voucher.voucherNo}</td>
                                        <td>{safeFormatCurrency(voucher.amount)}</td>
                                        <td>{voucher.vehicleRegistrationNumber || "N/A"}</td>
                                        <td>{new Date(voucher.dateCreated).toLocaleDateString()}</td>
                                        <td>{new Date(voucher.expiryDate).toLocaleDateString()}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        {vouchers_total_records > 1 && (
                            <Pagination
                                currentPage={currentPage}
                                totalPages={Math.ceil(vouchers_total_records / itemsPerPage)}
                                setCurrentPage={setCurrentPage}
                            />
                        )}
                    </>
                )}

                <Modal
                    show={showPersonalTopupModal}
                    onHide={() => setShowPersonalTopupModal(false)}
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Top Up Personal Wallet</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="mb-3 p-3 bg-light rounded">
                            <div><strong>Wallet ID:</strong> {selectedPersonalWallet?.walletId}</div>
                            <div><strong>Customer:</strong> {getPersonalWalletName(selectedPersonalWallet)}</div>
                            <div><strong>Current balance:</strong> {safeFormatCurrency(selectedPersonalWallet?.balance ?? selectedPersonalWallet?.credit)}</div>
                        </div>

                        <Form.Group className="mb-3">
                            <Form.Label>Top-up Amount</Form.Label>
                            <Form.Control
                                type="number"
                                min="0.01"
                                step="0.01"
                                placeholder="Enter amount"
                                value={personalTopupAmount}
                                onChange={(e) => setPersonalTopupAmount(e.target.value)}
                            />
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>Transaction Reference</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="M-Pesa code or cheque number"
                                value={personalTopupReference}
                                onChange={(e) => setPersonalTopupReference(e.target.value)}
                            />
                            <Form.Text className="text-muted">
                                Enter the M-Pesa transaction code, cheque number, or other payment reference.
                            </Form.Text>
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            variant="secondary"
                            onClick={() => setShowPersonalTopupModal(false)}
                            disabled={submittingPersonalTopup}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="primary"
                            onClick={handlePersonalTopupSubmit}
                            disabled={submittingPersonalTopup}
                        >
                            {submittingPersonalTopup ? "Submitting..." : "Top Up"}
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Modal
                    show={showStatementModal}
                    onHide={() => setShowStatementModal(false)}
                    size="xl"
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            Wallet Statement - {selectedPersonalWallet?.walletId}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-3">
                            <div>
                                <div><strong>{getPersonalWalletName(selectedPersonalWallet)}</strong></div>
                                <div className="text-muted">Current balance: {safeFormatCurrency(selectedPersonalWallet?.balance ?? selectedPersonalWallet?.credit)}</div>
                            </div>

                            <div className="d-flex flex-wrap align-items-end gap-2">
                                <Form.Group>
                                    <Form.Label>From</Form.Label>
                                    <Form.Control
                                        type="date"
                                        value={statementStartDate}
                                        max={statementEndDate}
                                        onChange={(e) => setStatementStartDate(e.target.value)}
                                    />
                                </Form.Group>
                                <Form.Group>
                                    <Form.Label>To</Form.Label>
                                    <Form.Control
                                        type="date"
                                        value={statementEndDate}
                                        min={statementStartDate}
                                        onChange={(e) => setStatementEndDate(e.target.value)}
                                    />
                                </Form.Group>
                                <Button
                                    variant="primary"
                                    onClick={() => loadPersonalWalletStatement()}
                                    disabled={statementLoading}
                                >
                                    {statementLoading ? "Loading..." : "Apply"}
                                </Button>
                                <Button
                                    variant="success"
                                    onClick={() => exportPersonalWalletStatement()}
                                    disabled={statementDownloading}
                                >
                                    {statementDownloading ? "Exporting..." : "Export Excel"}
                                </Button>
                            </div>
                        </div>

                        <div className="table-responsive">
                            <table className="table table-sm table-striped align-middle">
                                <thead>
                                    <tr>
                                        <th>Date</th>
                                        <th>Description</th>
                                        <th>Vehicle</th>
                                        <th>Station</th>
                                        <th className="text-end">Litres</th>
                                        <th className="text-end">Price</th>
                                        <th className="text-end">Credit</th>
                                        <th className="text-end">Debit</th>
                                        <th className="text-end">Balance</th>
                                        <th>Reference</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {statementLoading ? (
                                        <tr>
                                            <td colSpan="10" className="text-center py-4">Loading statement...</td>
                                        </tr>
                                    ) : statementRows.length === 0 ? (
                                        <tr>
                                            <td colSpan="10" className="text-center py-4">No transactions found for this period.</td>
                                        </tr>
                                    ) : (
                                        statementRows.map((transaction) => (
                                            <tr key={transaction.id}>
                                                <td>{new Date(transaction.dateCreated).toLocaleString()}</td>
                                                <td>{transaction.description}</td>
                                                <td>{transaction.vehicleRegistrationNumber || "-"}</td>
                                                <td>{transaction.stationName || "-"}</td>
                                                <td className="text-end">{transaction.litres == null ? "-" : Number(transaction.litres).toFixed(2)}</td>
                                                <td className="text-end">{transaction.pricePerLitre == null ? "-" : safeFormatCurrency(transaction.pricePerLitre)}</td>
                                                <td className="text-end text-success">{transaction.credit > 0 ? safeFormatCurrency(transaction.credit) : "-"}</td>
                                                <td className="text-end text-danger">{transaction.debit > 0 ? safeFormatCurrency(transaction.debit) : "-"}</td>
                                                <td className="text-end fw-semibold">{safeFormatCurrency(transaction.runningBalance)}</td>
                                                <td>{transaction.walletReference}</td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </Modal.Body>
                </Modal>

                {/* Customer balance top-up modal */}
                <Modal show={showModal} onHide={() => setShowModal(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>Top-up Balance</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Form.Group className="mb-3">
                                <Form.Label>Top-up Amount</Form.Label>
                                <Form.Control
                                    type="number"
                                    placeholder="Enter amount"
                                    value={topUpAmount}
                                    onChange={(e) => setTopUpAmount(e.target.value)}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>Payment Reference</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter payment reference"
                                    value={paymentReference}
                                    onChange={(e) => setPaymentReference(e.target.value)}
                                />
                            </Form.Group>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowModal(false)}>
                            Cancel
                        </Button>
                        <Button variant="primary" onClick={handleTopUpSubmit}>
                            Submit
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Main>
        </>
    );
};

export default ListCustomerBalances;